import React from "react";
import Banner from "../props/heading";


export default function Home(){

    return(
        <main>
            <div className="background">
                <div className="shape shape1"></div>
                <div className="shape shape2"></div>
                <div className="shape shape3"></div>
                <div className="triangle shape4"></div>
                <div className="triangle shape5"></div>
            </div>

            <Banner 
            heading="heading"
            title="title"
            myTitle="Bringing Ideas to Life, One Project at a Time"
            paragraph="paragraph"
            mission="mission"
            myMission="My mission is to inspire action, foster collaboration, and create innovative solutions through continuous learning and effective communication. Together, we turn ideas into impactful results."

            />
            
            
        </main>
    )
}